import React from 'react';

// CreaLabs brand wordmark (user-provided logo image).
// Source is a transparent PNG with a light/white wordmark, ideal for dark UI.
export default function Logo({ className = '', height = 26 }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/crealabs-logo.png`}
      alt="CREALABS"
      height={height}
      style={{ height: `${height}px`, width: 'auto' }}
      className={className}
      draggable={false}
    />
  );
}
